import ProductViewControlController from './view-control';

export default class ScansScanProductAutomatedReportsController extends ProductViewControlController {}
